import * as React from 'react'
import { AppConsentContext } from '../appConsentContext'

export const useCookieConsent = () => {
  return React.useContext(AppConsentContext)
}

// todo add audioContext as custom hook
